import { fade, makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	({ spacing, palette, typography }) => ({
		wrapper: {
			position: 'relative',
			width: '100%',
			height: '100%',
			color: ({ active }) => (active ? palette.primary.main : palette.primary.contrastText),
		},
		textInput: {
			height: '100%',
		},
		focused: {
			background: ({ active }) => (active ? null : 'none !important'),
			color: `${palette.primary.main} !important`,

			border: `1px solid ${palette.primary.main} !important`,
			boxShadow: ({ multiple, isBuilderMode }) =>
				multiple && !isBuilderMode ? `0 0 0 2px ${palette.primary.light}` : null,
		},
		buttonIcon: {
			borderRadius: 0,
			padding: 0,
			position: 'absolute',
			right: 12,
			zIndex: 10,
			color: 'inherit',
		},
		icon: {
			color: 'inherit',
			width: spacing(3),
			height: spacing(3),
		},
		progress: {
			position: 'absolute',
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
			margin: 'auto',
			zIndex: 1,
			color: 'inherit',
		},
		checkIcon: {
			width: spacing(2.5),
			height: spacing(2.5),
			marginRight: spacing(0.5),
			marginLeft: spacing(-2.75),
			color: 'inherit',
		},
		adornedStart: {
			paddingLeft: spacing(0.7),
		},
		adornedEnd: {
			paddingRight: 0,
		},
		root: {
			height: '100%',
			padding: spacing(1.5, 3.25),
			backgroundColor: ({ active }) => (active ? 'transparent' : palette.primary.main),
			border: '1px solid currentColor !important',
			color: 'inherit',

			'&:hover': {
				backgroundColor: ({ active }) => (active ? fade(palette.primary.main, 0.05) : palette.primary.dark),
			},
		},

		input: {
			height: '100%',
			minHeight: spacing(3),
			textAlign: 'center',
			padding: 0,
			margin: spacing(0, 1.5),
			color: 'inherit',
			...typography.body2,
			'&:autofill': {
				'-webkit-text-fill-color': palette.primary.main,
				'-webkit-box-shadow': `0 0 0 50px ${palette.background.default} inset`,
			},

			'&::placeholder': {
				opacity: '1 !important',
				...typography.body2,
			},
		},
		notchedOutline: {
			border: 'none !important',
		},
	}),
	{ name: 'Questions-AnswerTypes-MultipleChoiceButtons-OptionOtherItem' },
)

export default useStyles
